/**
 * @file 神策埋点封装 https://manual.sensorsdata.cn/sa/latest/sdk-web-7545024.html
 * 查看请求解码地址：https://www.sensorsdata.cn/tools/decode.html
 * 也可以直接在控制台打开打开神策的埋点记录，输入：sensorsDataAnalytic201505.enableLocalLog()
 * 埋点文档地址 https: //confluence.yijin.io/pages/viewpage.action?pageId=63457818
 */
import { isBrowser } from '@web3/base-utils';
import { PageViewConfigInfo } from './types';
import { addWalletCommonParamPlugin, setTrackWalletInfo } from './plugin';

type TrackItem = [string, Record<string, string | number | boolean>]; // event, ops

export const getSensors = () => {
  if (isBrowser) {
    return (window as any)?.sensors;
  }
};

const initialized = false;
const pendingTrackQueue: TrackItem[] = [];

const runPendingTracking = () => {
  for (const item of pendingTrackQueue) {
    getSensors()?.track(...item);
  }
  pendingTrackQueue.length = 0;
};

// 初始化
export const sensorsInit = async ({
  appBase,
  pageViewConfig = [],
  userWalletStore,
}: {
  appBase?: string;
  pageViewConfig?: PageViewConfigInfo[];
  userWalletStore?: any;
} = {}) => {
  if (!isBrowser || initialized) return;

  // 增加wallet通用参数
  if (userWalletStore) {
    userWalletStore?.on?.('update', (walletState) => {
      setTrackWalletInfo({ walletId: walletState?.walletId ?? '' });
    });
  }
  addWalletCommonParamPlugin();
};

export const login = async (id: string) => {
  getSensors()?.login(id);
};

export const scTrack = async (event: TrackItem[0], ops: TrackItem[1] = {}) => {
  if (!isBrowser) return;
  const sensors = getSensors();
  if (sensors?.track) {
    // todo: 解决sensors异步加载无法检测的问题后变更处理方法
    if (pendingTrackQueue.length) {
      runPendingTracking();
    }
    sensors?.track(event, ops);
  } else {
    pendingTrackQueue.push([event, ops]);
  }
};

/**
 * 点击埋点上报
 * @param data 埋点参数
 */
export const userClickTrack = (
  data: { button_name: string; page_name?: string } & Record<
    string,
    string | number
  >
) => {
  scTrack('Web3UserClick', data);
};

/**
 * 曝光埋点上报
 * @param data 埋点参数
 */
export const pageViewTrack = (
  data?: { page_name: string } & Record<string, string | number>
) => {
  scTrack('Web3PageView', data || {});
};

export { setTrackWalletInfo } from './plugin';
